import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

interface QualityBarProps {
  value: number;
}

const QualityBar: React.FC<QualityBarProps> = ({ value }) => {
  const getColor = () => {
    if (value >= 90) return "success";
    if (value >= 70) return "warning";
    return "error";
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <LinearProgress
        variant="determinate"
        value={value}
        color={getColor()}
        sx={{ width: 100, height: 8, borderRadius: 4 }}
      />
      <Typography variant="body2" sx={{ fontWeight: "medium" }}>
        {value}%
      </Typography>
    </Box>
  );
};

export default QualityBar;